import { AfterViewInit, Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { AppTitleService } from '../../../services/app-title.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ListadoDocumentoPaginado, Documento } from '../../../models/Document';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../commons/toast.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentTypeService } from '../../../services/document-type.service';
import { DocumentoService } from '../../../services/documento.service';
import { DateService, MY_DATE_FORMATS } from '../../../shared/date.service';
import { FilterData } from '../../borrador/borrador.component';
import { DocumentType } from '../../../models/DocumentType';
import { merge, startWith, switchMap, catchError, EMPTY, map } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { EstadosDocumentoComponent } from "../../../commons/estados-documento/estados-documento.component";
import { TareaService } from '../../../services/tarea.service';
import { SubestadoTareaPipe } from '../../../pipes/subestado-tarea.pipe';
import { CustomPaginator } from '../../../commons/custom-paginator/custom-paginator';
import { NoDataFoundComponent } from "../../../commons/no-data-found/no-data-found.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AutofocusDirective } from '../../../helpers/autofocus.directive';
import { ReportService } from '../../../services/report.service';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../../commons/dlg-confirm/dlg-confirm.component';
import { DlgAlertComponent } from '../../../commons/dlg-alert/dlg-alert.component';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'app-tarea-recibida-enviada',
  imports: [
    NgClass,
    MatTableModule, MatPaginatorModule, MatSortModule,
    MatSnackBarModule,
    MatToolbarModule, MatButtonModule, MatIconModule,
    MatInputModule, MatFormFieldModule,
    FormsModule, ReactiveFormsModule,
    MatSelectModule, AutofocusDirective,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressBarModule,
    EstadosDocumentoComponent,
    SubestadoTareaPipe,
    NoDataFoundComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './tarea-recibida-enviada.component.html',
  styleUrl: './tarea-recibida-enviada.component.scss'
})
export class TareaRecibidaEnviadaComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['select', 'estados', 'fechaRegistro', 'comentario', 'fechaExpira', 'avance', 'asunto', 'numeroDocumento'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  tipoAtencion = this.route.snapshot.url[0].path === "enviada" ? "2" : "1";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = true;

  documentTypes: DocumentType[] | undefined

  dateRangeInWeeks = 5
  initialDate = "2025-01-02"
  maxDate = new Date()

  snackbarData: ScnackbarData = {}

  mostrarTodasTareas = 0;

  //tipoBandeja = "2"

  filterForm = new FormGroup({
    fechaInicio: new FormControl(new Date(), {
      validators: [
        Validators.required
      ]
    }),
    fechaFin: new FormControl(new Date(), {
      validators: [
        Validators.required,
      ]
    }),
    searchText: new FormControl(""),
    numero: new FormControl('', [Validators.pattern('^(?:\\d{4}-)?\\d+$')]),
    documentType: new FormControl("")
  })

  utilService = inject(UtilService);
  contadorTareas = -1
  constructor(
    private tareaService: TareaService,
    private documentTypeService: DocumentTypeService,
    private documentoSrv: DocumentoService,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private reportService: ReportService,
    private toast: ToastService,
    private dateService: DateService
  ) {
    inject(AppTitleService).setTitle((this.tipoAtencion === "2") ? 'Tareas Enviadas' : 'Tareas Recibidas');

    if (this.tipoAtencion !== "2") {
      effect((e:any) => {
      const contTareas:any = this.utilService.signalTasks();
      if(!this.contadorTareas) { return}      
      if (!contTareas.recibido) {
        return; 
      }
      if (this.contadorTareas == -1) { 
        this.contadorTareas = contTareas.recibido;
        return;
      }
      if (this.contadorTareas != contTareas) {
        this.contadorTareas = contTareas.recibido;
        this.reload();
      }      
    });
    }

  }

  ngOnInit(): void {
    const currentDate = new Date()
    let initialDate = new Date(this.initialDate)
    //initialDate.setDate(currentDate.getDate() - this.dateRangeInWeeks * 7)
    this.filterForm.controls.fechaFin.setValue(currentDate)
    this.filterForm.controls.fechaInicio.setValue(initialDate)
  }

  ngAfterViewInit(): void {

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.documentTypeService.list().subscribe({
      next: (response) => {
        this.documentTypes = response;
        let documentTypeDescription = "Oficio"

        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);

        if (defaultType) {
          this.filterForm.controls.documentType.setValue("-1")

          merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
            switchMap(() => {
              this.isLoadingResults = true;
              const filterData = this.createFilterData()
              return this.tareaService!.listado(
                this.tipoAtencion,
                filterData.initialDate,
                filterData.endDate,
                filterData.searchText,
                filterData.documentType,
                this.paginator.pageIndex,
                filterData.numero ? filterData.numero : null,
                this.mostrarTodasTareas
              ).pipe(catchError(() => EMPTY));
            }),
            map(data => {
              this.isLoadingResults = false;
              if (data === null) {
                return [];
              }
              this.resultsLength = data.totalDocumentos;
              return data;
            })
          ).subscribe({
            next: (response) => {
              this.documentsPaginated = response as ListadoDocumentoPaginado
              this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
              Object.keys(this.filterForm.controls).forEach(controlName => {
                if (controlName !== "searchText" && controlName !== "numero") {
                  this.filterForm.get(controlName)?.valueChanges.subscribe(_ => {
                    this.reload();
                  });
                }
              });
            }
          })
        }
      }
    });
  }

  onCallReport(obj: any) {
    var params = {
      P_USUARIO: obj.usr,
      P_DEPARTAMENTO: obj.dpto,
      P_FECHA_INICIO: obj.fi,
      P_FECHA_FIN: obj.ff,
      P_CODIGOS: obj.ids
    }
    var url: any = this.reportService.getUrl("rpListadoHojaGuiaTarea", params);
    this.reportService.openReport(url as string, 'Listado_hoja_guia_tareas.pdf');
  }

  onCambiarEstadoImpresoConfirm(obj: any) {
    const data: DlgConfirmComponentData = {
      title: "Actualizar estado?",
      message: "¿Desea cambiar el estado impreso de las tareas mostradas?",
      confirmLabel: "Si, cambiar",
      closeLabel: "No"
    }
    const dialogRef = this.dialog.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.tareaService.updateEstadoTareasHojaGuia(1, obj.ids).subscribe({
          next: (res: any) => {
            this.dialog.open(DlgAlertComponent, {
              data: {
                title: 'Hoja gu\xeda',
                message: 'Estado impreso actualizado'
              }
            });
          }
        })
      }
    });
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.reload();
  }

  reload() {
    this.filterForm.controls.numero.setValue("");
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  onKeyUpFlow(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.buscarFlow();
  }

  buscarFlow() {
    this.filterForm.controls.searchText.setValue("")
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  fectchAndInitializeDataSource() {
    this.paginator.pageIndex = 0
    const filterData = this.createFilterData()
    this.isLoadingResults = true;
    this.tareaService!.listado(
      this.tipoAtencion,
      filterData.initialDate,
      filterData.endDate,
      filterData.searchText,
      filterData.documentType,
      this.paginator.pageIndex,
      filterData.numero ? filterData.numero : null,
      this.mostrarTodasTareas
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response as ListadoDocumentoPaginado
        this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
        this.resultsLength = this.documentsPaginated.totalDocumentos;
        this.isLoadingResults = false;
      }
    })
  }

  private createFilterData(): FilterData {
    const filterData: FilterData = {
      initialDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!),
      endDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!),
      documentType: parseInt(this.filterForm.controls.documentType.value!),
      numero: this.filterForm.controls.numero.value?.toString() ?? undefined,
      searchText: this.filterForm.controls.searchText.value!
    }
    return filterData
  }

  reAsign() {
  }

  archivar() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("/documento/archivar", { state: taskData })
  }

  onAddComment() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("comentar", { state: taskData })
  }

  onAddTask() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("tarea", { state: taskData })
  }

  clickedRow(row: Documento) {
    // Si el documento no está leído, marcarlo como leído
    if (!row.leido || row.leido === 0) {
      this.documentoSrv.marcarLeido(row.idTarea).subscribe({
        next: () => {
          row.leido = 1; // Actualizar localmente después del éxito
        },
        error: (err) => {
          console.error('Error marcando documento como leído:', err);
        }
      });
    }

    const data = {
      bandejaIndex: 4
    }
    this.router.navigateByUrl("/resumen/" + row.idTarea, { state: data })
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data.filter(row => row.subEstadoTarea !== 2));
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDateNoTime(date)
  }

  mostrarTodo(e: any) {
    this.mostrarTodasTareas = e.checked ? 1 : 0
    this.fectchAndInitializeDataSource();
  }

}
